module.exports = __webpack_public_path__ + "static/media/bp_measure_step3.b2a0ae52.gif";